import React from "react";
import "./styles/LiquidGlass.css";
import HeaderLiquid from "./components/header/HeaderLiquid";
import ProductLandingPageLiquid from "./pages/ProductLandingPageLiquid";

function AppLiquidGlass() {
  return (
    <div className="app-liquid-glass">
      <HeaderLiquid />
      <ProductLandingPageLiquid />
    </div>
  );
}

export default AppLiquidGlass;
